import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import ContentList1 from '../components/content-list1'
import FAQ1 from '../components/faq1'
import Contact10 from '../components/contact10'
import './why-us.css'

const WhyUs = (props) => {
  return (
    <div className="why-us-container">
      <Helmet>
        <title>Why-Us - Allstream Global Business Solutions</title>
        <meta
          name="description"
          content='"Streamline your business with Allstream – expert Business Setup, HR, Finance, IT, and Admin support for fast, hassle-free growth."'
        />
        <meta
          property="og:title"
          content="Why-Us - Allstream Global Business Solutions"
        />
        <meta
          property="og:description"
          content='"Streamline your business with Allstream – expert Business Setup, HR, Finance, IT, and Admin support for fast, hassle-free growth."'
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/231f249b-b608-4355-8168-0f58a5abbd5a/0c40ed70-952b-4901-8fa3-40ab70c3e200?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="why-us-text100">#About Us</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="why-us-text101">#Why Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="why-us-text102">#</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="why-us-text103">#</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="why-us-text104">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="why-us-text105">About Us</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="why-us-text106">Services</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="why-us-text107">Contact</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="why-us-text108">Contact Us</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="why-us-text109">Secondary Action</span>
          </Fragment>
        }
        page1Description={
          <Fragment>
            <span className="why-us-text110">Page One Description</span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="why-us-text111">Page Two Description</span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="why-us-text112">Page Three Description</span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="why-us-text113">Page Four Description</span>
          </Fragment>
        }
      ></Navbar8>
      <ContentList1
        text454={
          <Fragment>
            <span className="why-us-text114">
              {' '}
              Because we don’t just help you start a company — we help you run
              it smarter, leaner, and more profitably.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        text455={
          <Fragment>
            <span className="why-us-text115">
              {' '}
              Allstream Global is built for modern businesses that want to skip
              the admin headache and focus on growth. We go beyond setup — we’re
              your long-term partner for operations, compliance, HR, finance,
              procurement, IT, and PRO services.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        text456={
          <Fragment>
            <span className="why-us-text116">Feature</span>
          </Fragment>
        }
        text457={
          <Fragment>
            <span className="why-us-text117">Allstream Global</span>
          </Fragment>
        }
        text458={
          <Fragment>
            <span className="why-us-text118">Traditional Agents</span>
          </Fragment>
        }
        text459={
          <Fragment>
            <span className="why-us-text119">In-House Team</span>
          </Fragment>
        }
        text460={
          <Fragment>
            <span className="why-us-text120">
              Full admin outsourcing after setup
            </span>
          </Fragment>
        }
        text461={
          <Fragment>
            <span className="why-us-text121">✔️</span>
          </Fragment>
        }
        text462={
          <Fragment>
            <span className="why-us-text122">❌</span>
          </Fragment>
        }
        text463={
          <Fragment>
            <span className="why-us-text123">❌</span>
          </Fragment>
        }
        text464={
          <Fragment>
            <span className="why-us-text124">Dedicated account manager</span>
          </Fragment>
        }
        text465={
          <Fragment>
            <span className="why-us-text125">✔️</span>
          </Fragment>
        }
        text466={
          <Fragment>
            <span className="why-us-text126">❌</span>
          </Fragment>
        }
        text467={
          <Fragment>
            <span className="why-us-text127">❌</span>
          </Fragment>
        }
        text468={
          <Fragment>
            <span className="why-us-text128">
              End-to-end support (setup → operations)
            </span>
          </Fragment>
        }
        text469={
          <Fragment>
            <span className="why-us-text129">✔️</span>
          </Fragment>
        }
        text470={
          <Fragment>
            <span className="why-us-text130">❌</span>
          </Fragment>
        }
        text471={
          <Fragment>
            <span className="why-us-text131">✔️</span>
          </Fragment>
        }
        text472={
          <Fragment>
            <span className="why-us-text132">
              Expert team across 5+ functions
            </span>
          </Fragment>
        }
        text473={
          <Fragment>
            <span className="why-us-text133">✔️</span>
          </Fragment>
        }
        text474={
          <Fragment>
            <span className="why-us-text134">❌</span>
          </Fragment>
        }
        text475={
          <Fragment>
            <span className="why-us-text135">✔️ (but expensive)</span>
          </Fragment>
        }
        text476={
          <Fragment>
            <span className="why-us-text136">Transparent flat pricing</span>
          </Fragment>
        }
        text477={
          <Fragment>
            <span className="why-us-text137">✔️</span>
          </Fragment>
        }
        text478={
          <Fragment>
            <span className="why-us-text138">❌</span>
          </Fragment>
        }
        text479={
          <Fragment>
            <span className="why-us-text139">❌</span>
          </Fragment>
        }
        text480={
          <Fragment>
            <span className="why-us-text140">
              Scalable as your business grows
            </span>
          </Fragment>
        }
        text481={
          <Fragment>
            <span className="why-us-text141">✔️</span>
          </Fragment>
        }
        text482={
          <Fragment>
            <span className="why-us-text142">❌</span>
          </Fragment>
        }
        text483={
          <Fragment>
            <span className="why-us-text143">Limited</span>
          </Fragment>
        }
        text484={
          <Fragment>
            <span className="why-us-text144">Role</span>
          </Fragment>
        }
        text485={
          <Fragment>
            <span className="why-us-text145">
              Min Average Monthly Salary (AED)
            </span>
          </Fragment>
        }
        text486={
          <Fragment>
            <span className="why-us-text146">
              Min Average Annual Cost (AED)
            </span>
          </Fragment>
        }
        text487={
          <Fragment>
            <span className="why-us-text147">HR</span>
          </Fragment>
        }
        text488={
          <Fragment>
            <span className="why-us-text148">7,000</span>
          </Fragment>
        }
        text489={
          <Fragment>
            <span className="why-us-text149">84,000</span>
          </Fragment>
        }
        text490={
          <Fragment>
            <span className="why-us-text150">Accounts</span>
          </Fragment>
        }
        text491={
          <Fragment>
            <span className="why-us-text151">8,000</span>
          </Fragment>
        }
        text492={
          <Fragment>
            <span className="why-us-text152">96,000</span>
          </Fragment>
        }
        text493={
          <Fragment>
            <span className="why-us-text153">Procurement</span>
          </Fragment>
        }
        text494={
          <Fragment>
            <span className="why-us-text154">6,000</span>
          </Fragment>
        }
        text495={
          <Fragment>
            <span className="why-us-text155">72,000</span>
          </Fragment>
        }
        text496={
          <Fragment>
            <span className="why-us-text156">IT</span>
          </Fragment>
        }
        text497={
          <Fragment>
            <span className="why-us-text157">7,000</span>
          </Fragment>
        }
        text498={
          <Fragment>
            <span className="why-us-text158">84,000</span>
          </Fragment>
        }
        text499={
          <Fragment>
            <span className="why-us-text159">PRO/Admin</span>
          </Fragment>
        }
        text500={
          <Fragment>
            <span className="why-us-text160">6,000</span>
          </Fragment>
        }
        text501={
          <Fragment>
            <span className="why-us-text161">72,000</span>
          </Fragment>
        }
        text502={
          <Fragment>
            <span className="why-us-text162">TOTAL</span>
          </Fragment>
        }
        text503={
          <Fragment>
            <span className="why-us-text163">34,000/mo</span>
          </Fragment>
        }
        text504={
          <Fragment>
            <span className="why-us-text164">408,000/yr</span>
          </Fragment>
        }
        text505={
          <Fragment>
            <span className="why-us-text165">Service</span>
          </Fragment>
        }
        text506={
          <Fragment>
            <span className="why-us-text166">Monthly (AED)</span>
          </Fragment>
        }
        text507={
          <Fragment>
            <span className="why-us-text167">Annual (AED)</span>
          </Fragment>
        }
        text508={
          <Fragment>
            <span className="why-us-text168">Full Admin Support Package</span>
          </Fragment>
        }
        text509={
          <Fragment>
            <span className="why-us-text169">12,500</span>
          </Fragment>
        }
        text510={
          <Fragment>
            <span className="why-us-text170">150,000</span>
          </Fragment>
        }
        text511={
          <Fragment>
            <span className="why-us-text171">In-House Team</span>
          </Fragment>
        }
        text512={
          <Fragment>
            <span className="why-us-text172">Allstream Global </span>
          </Fragment>
        }
        text513={
          <Fragment>
            <span className="why-us-text173">Monthly Cost</span>
          </Fragment>
        }
        text514={
          <Fragment>
            <span className="why-us-text174">34,000+</span>
          </Fragment>
        }
        text515={
          <Fragment>
            <span className="why-us-text175">12,500</span>
          </Fragment>
        }
        text516={
          <Fragment>
            <span className="why-us-text176">Annual Cost</span>
          </Fragment>
        }
        text517={
          <Fragment>
            <span className="why-us-text177">408,000+</span>
          </Fragment>
        }
        text518={
          <Fragment>
            <span className="why-us-text178">150,000</span>
          </Fragment>
        }
        text519={
          <Fragment>
            <span className="why-us-text179">Annual Savings</span>
          </Fragment>
        }
        text520={
          <Fragment>
            <span className="why-us-text180">—</span>
          </Fragment>
        }
        text521={
          <Fragment>
            <span className="why-us-text181">258,000+</span>
          </Fragment>
        }
        text537={
          <Fragment>
            <span className="why-us-text182">
              Who want to focus on product, not paperwork
            </span>
          </Fragment>
        }
        text538={
          <Fragment>
            <span className="why-us-text183">
              Who want expert admin without bloated overhead
            </span>
          </Fragment>
        }
        text539={
          <Fragment>
            <span className="why-us-text184">Launching UAE branches</span>
          </Fragment>
        }
        text540={
          <Fragment>
            <span className="why-us-text185">
              Who don’t want to manage an office full of admin staff
            </span>
          </Fragment>
        }
        heading51={
          <Fragment>
            <span className="why-us-text186">Why Choose Allstream Global?</span>
          </Fragment>
        }
        heading52={
          <Fragment>
            <span className="why-us-text187">What Makes Us Different</span>
          </Fragment>
        }
        heading53={
          <Fragment>
            <span className="why-us-text188">Real Cost Comparison</span>
          </Fragment>
        }
        heading54={
          <Fragment>
            <span className="why-us-text189">
              <span>Let’s talk numbers — because facts close deals.</span>
              <br></br>
            </span>
          </Fragment>
        }
        heading55={
          <Fragment>
            <span className="why-us-text192">
              Outsource to Allstream Global
            </span>
          </Fragment>
        }
        heading56={
          <Fragment>
            <span className="why-us-text193">📊 Summary</span>
          </Fragment>
        }
        heading63={
          <Fragment>
            <span className="why-us-text194">Who This is Perfect For</span>
          </Fragment>
        }
        heading64={
          <Fragment>
            <span className="why-us-text195">Startups</span>
          </Fragment>
        }
        heading65={
          <Fragment>
            <span className="why-us-text196">SMEs</span>
          </Fragment>
        }
        heading66={
          <Fragment>
            <span className="why-us-text197">International Companies</span>
          </Fragment>
        }
        heading67={
          <Fragment>
            <span className="why-us-text198">Business Owners</span>
          </Fragment>
        }
        heading541={
          <Fragment>
            <span className="why-us-text199">Hiring an In-House Team</span>
          </Fragment>
        }
      ></ContentList1>
      <FAQ1 rootClassName="faq1root-class-name"></FAQ1>
      <Contact10
        content1={
          <Fragment>
            <span className="why-us-text200">
              Have questions or ready to get started? Reach out to us for more
              information.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="why-us-text201">Contact Us</span>
          </Fragment>
        }
      ></Contact10>
    </div>
  )
}

export default WhyUs
